<template>
	<div>
		<ul class="row">
			<li class="col">
				<router-link to="/home" class="nav-link text-dark">
					<i class="fa fa-safari fa-2x"></i><br> Find Out More
				</router-link>	
			</li>
			<li class="col" v-for="(value, key, index) in leftLists" v-if="key == 'Reports'">
				<span v-for="(value, key) in value"  v-if="key == 'Assessment Reports'">
					<router-link :to="{name:value.route, params :{id:value.id}}" class="nav-link text-dark">
						<i class="fa fa-university fa-2x" aria-hidden="true"></i><br> Local
					</router-link>	
				</span>
			</li>
			<li class="col" v-for="(value, key, index) in leftLists" v-if="key == 'Consulting'">
				<router-link :to="{name:value.route, params :{id:value.id}} " class="nav-link text-dark">
					<i class="fa fa-commenting-o fa-2x"></i><br> Consulting
				</router-link>	
			</li>
			<li class="col">
				<router-link to="/accountSettings" class="nav-link text-dark">
					<i class="fa fa-user fa-2x"></i><br> My Account
				</router-link>
			</li>
		</ul>
	</div>
</template>
<script>
	export default({
		name: 'footerpage',
		data: function() {
			return {
				leftLists: []
			}

		},
		created: function() {
			var self = this;
			this.$axios.post('/api/pc/getmenu').then(data => {
				var leftLists = data.data.data;
				this.leftLists = leftLists;
			}, function(response) {
				console.info(response);
				if(response) {
					console.log("失败");
				}
			})
		},

	})
</script>